// extracted by mini-css-extract-plugin
export default {"root":"SassMobileMenu__root--2SeVt","user":"SassMobileMenu__user--2AenH","menu_items":"SassMobileMenu__menu_items--3r0Xt","contentWrapper":"SassMobileMenu__contentWrapper--qRgHF"};